"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosCommissionSchema = exports.APosCommissionScheduleSchema = exports.APosCommissionStatusSchema = exports.APosCommissionTypeSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
// Two commission types only (per spec): flat $ per unit, or % of the price paid.
exports.APosCommissionTypeSchema = zod_1.z.enum(['flat_per_unit', 'percent_of_sale']);
// Lifecycle mirrors promotions (draft/scheduled/active/paused/expired) plus the
// soft-delete tombstone used by the delete handler.
exports.APosCommissionStatusSchema = zod_1.z.enum([
    'draft', 'scheduled', 'active', 'paused', 'expired', 'deleted',
]);
exports.APosCommissionScheduleSchema = zod_1.z.object({
    startDate: zod_1.z.number().optional(), // epoch ms; defaults to now on create
    endDate: zod_1.z.number().optional(), // epoch ms; omitted = no expiry
});
exports.APosCommissionSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    commissionId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(150),
    description: zod_1.z.string().max(500).optional(),
    type: exports.APosCommissionTypeSchema,
    // For flat_per_unit: dollars per unit. For percent_of_sale: a percent (0–100).
    value: zod_1.z.number().nonnegative(),
    // Only meaningful for percent_of_sale: cap the per-line commission in dollars.
    maxAmount: zod_1.z.number().nonnegative().optional(),
    schedule: exports.APosCommissionScheduleSchema.default({}),
    status: exports.APosCommissionStatusSchema.default('draft'),
    usageCount: zod_1.z.number().int().nonnegative().default(0),
    totalCommissionGiven: zod_1.z.number().nonnegative().default(0),
}).merge(timestamps_schema_1.TimestampsSchema);
//# sourceMappingURL=commission.schema.js.map